import { translate } from "app/filters/i18nFilter";

export const getNoData = () => ({
    title: translate("si.company-analysis.company-data.card.empty.header"),
    subtitle: translate("si.company-analysis.company-data.card.empty.text"),
});

export const COMPANY_ANALYSIS_TAB_NAMES = {
    digitalAssets: "Digital assets",
    technologies: "Technologies",
    competitors: "Competitors",
    contacts: "Contacts",
    signals: "Signals",
    overview: "Overview",
};

export const WEBSITE_ANALYSIS_TAB_NAMES = {
    performance: "Performance",
    competitors: "Competitors",
    technologies: "Technologies",
    trafficEngagement: "Traffic and engagement",
    geography: "Geography",
    marketingChannels: "Marketing Channels",
    marketingSearchOverview: "Marketing Search Overview",
    marketingKeywords: "Marketing Keywords",
    marketingSearchAds: "Marketing Search Ads",
    marketingSearchCompetitors: "Marketing Search Competitors",
    marketingReferralIncoming: "Marketing Referral Incoming",
    marketingReferralOutgoing: "Marketing Referral Outgoing",
    marketingDisplayAdNetworks: "Marketing Display Ad Networks",
    marketingDisplayCreative: "Marketing Display Creative",
    marketingDisplayOverview: "Marketing Display Overview",
    marketingPublisherOverview: "Marketing Publisher Overview",
    marketingDisplayPublishers: "Marketing Display Publishers",
    marketingDisplayVideos: "Marketing Display Videos",
    marketingSocialOverview: "Marketing Social Overview",
    subdomains: "Subdomains",
    pages: "Pages",
    folders: "Folders",
    demographics: "Demographics",
    audienceInterests: "Audience Interests",
};

export const WEBSITE_ANALYSIS_WIDGET_NAMES = {
    trafficEngagement: "Traffic and engagement",
    visitsOverTime: "Visits over time",
    geography: "Geography",
    trafficBranded: "Traffic Branded",
    trafficKeywords: "Traffic Keywords",
    paidSearchAds: "Paid Search Ads",
    paidSearchKeywords: "Paid Search Keywords",
};
